import React, { useEffect, useState } from 'react';
import {
  ButtonLoading,
  SimpleDialog,
  Icons,
  DatePickerPod,
  SelectV,
  createToast,
  NewLoading,
} from 'components';
import jMoment from 'moment-jalaali';
import { DatePicker } from 'components/LegacyPickers';
import { Grid, Button, Typography, Tooltip } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { enifyDateTime } from 'utility';
import {
  getTransactionWalletFormat,
  getTransactionGuildFormat,
  getTransactionBranchFormat,
  getTransactionImprestFormat,
  getTransactionDelegationFormat,
  getTransactionDelegationListFormat,
  getTransactionVoucherFormat,
  getTransactionInvoiceFormat,
  getTransactionInvoiceCreditorFormat,
  getTransactionSettlementWalletFormat,
  getTransactionSettlementGuildFormat,
  getTransactionImprestListFormat,
  getTransactionReportSummaryFormat,
  getImprestDepositReportFormat,
  getFeatureList,
} from './Services';

import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
const ReceiveFile = ({
  AccountList = null,
  branchList = null,
  type = null,
  paramsData = null,
  allowedTypesFormat = [],
  isFormatExport
}) => {
  const navigate = useNavigate();
  const [isOpenDg, setIsOpenDg] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectAccount, setSelectAccount] = useState(null);
  const [selectBranchList, setSelectBranchList] = useState(null);
  const [showElement, setShowElement] = useState(null);

  const [dateType, setDateType] = useState(null);
  const [startDate, setStartDate] = useState(
    paramsData?.startDate !== null ? paramsData?.startDate : null,
  );
  const [endDate, setEndDate] = useState(paramsData?.endDate !== null ? paramsData?.endDate : null);
  const methods = useForm();
  const classes = useStyles();

  const DATA_TYPE_LIST = [
    { value: 'ISSUANCE_DATE', label: 'تاریخ صدور' },
    { value: 'PAYMENT_DATE', label: 'تاریخ پرداخت' },
  ];

  const DEFAULT_DATE_TYPE_OPTIONS = [
    { value: 'START_DATE', label: 'محدوده‌ زمان شروع' },
    { value: 'EXPIRE_DATE', label: 'محدوده‌ زمان انقضا' },
    { value: 'CREATE_DATE', label: 'محدوده‌ زمان ایجاد' },
    { value: 'TRANSFER_DATE', label: 'تاریخ انتقال اعتبار' },
  ];

  const VOUCHER_LIST = [
    { value: 'CREATION_DATE', label: ' تاریخ ایجاد' },
    { value: 'EXPIRE_DATE', label: ' تاریخ انقضا' },
    { value: 'EFFECTIVE_DATE', label: ' تاریخ فعال شدن  ' },
  ];

  const DATE_TYPE_OPTIONS_MAP = {
    invoice: DATA_TYPE_LIST,
    voucher: VOUCHER_LIST,
    default: DEFAULT_DATE_TYPE_OPTIONS,
    invoiceCreditor: DATA_TYPE_LIST,
    reportSummary: DATA_TYPE_LIST,
  };

  const allowedTypes = [
    'invoice',
    'deligationList',
    'deligation',
    'voucher',
    'invoiceCreditor',
    'delegationList',
    'delegation',
  ];
  const fileTypeDownload = [
    {
      value: 'PDF',
      label: 'PDF',
      englishNumber: true,
    },
    {
      value: 'XLS',
      label: 'XLS',
      englishNumber: true,
    },
    {
      value: 'CSV',
      label: 'CSV',
      englishNumber: true,
    },
  ];

  const periodType = [
    { label: 'روزانه', value: 'DAILY' },
    { label: 'ماهانه', value: 'MONTHLY' },
    { label: 'سالانه', value: 'YEARLY' },
  ];

  const filteredFileTypes =
    allowedTypesFormat.length > 0
      ? fileTypeDownload.filter((item) => allowedTypesFormat.includes(item.value))
      : fileTypeDownload;

  const [fileFormat, setFileFormat] = useState(filteredFileTypes[0].value);

  const [periodTypeSelect, setPeriodTypeSelect] = useState('DAILY');

  const redirectPage = {
    wallet: '/ReportOfflineTransactions?source=TransactionsWallet',
    walletImprest: '/ReportOfflineTransactions?source=TransactionsWalletImprest',
    guild: '/ReportOfflineTransactions?source=TransactionsGuild',
    guildWithId: '/ReportOfflineTransactions?source=TransactionsGuildWithId',
    branch: '/ReportOfflineTransactions?source=BranchTransactions',
    branchWithId: '/ReportOfflineTransactions?source=BranchTransactionsWithId',
    imprest: '/ReportOfflineTransactions?source=imprestTransactions',
    imprestWithId: '/ReportOfflineTransactions?source=imprestTransactionsWithId',
    invoice: '/ReportOfflineTransactions?source=invoice',
    delegation: '/ReportOfflineTransactions?source=delegation',
    delegationList: '/ReportOfflineTransactions?source=delegationList',
    voucher: '/ReportOfflineTransactions?source=voucher',
    invoiceCreditor: '/ReportOfflineTransactions?source=invoiceCreditor',
    settlementWallet: '/ReportOfflineTransactions?source=settlementWallet',
    settlementWalletImprest: '/ReportOfflineTransactions?source=settlementWalletImprest',
    settlementGuild: '/ReportOfflineTransactions?source=settlementGuild',
    settlementGuildWithId: '/ReportOfflineTransactions?source=settlementGuildWithId',
    imprestList: '/ReportOfflineTransactions?source=imprestList',
    reportSummary: '/ReportOfflineTransactions?source=reportSummary',
    ImprestDepositReport: '/ReportOfflineTransactions?source=ImprestDepositReport',
  };
  
  const keyShowElement = {
    wallet: 'export-digital-account-statement', //transactionsWallet
    walletImprest: 'export-digital-account-statement', //transactionsWallet
    guild: 'export-guild-account-statement', //TransactionsGuild
    guildWithId: 'export-guild-account-statement', //TransactionsGuild/WithId
    branch: 'export-branch-account-statement', //Branch/Transactions
    branchWithId: 'export-branch-account-statement', //Branch/Transactions/WithId
    imprest: 'export-branch-account-statement', //Imprest/Transactions
    imprestWithId:'export-branch-account-statement', //Imprest/Transactions/WithId
    invoice: 'export-sales-invoice', //Invoice
    delegation: 'export-received-delegation', //Delegation
    delegationList: 'export-assigned-delegation', //DefineDelegation/List
    voucher: 'export-voucher-list', //Voucher
    invoiceCreditor: true, //invoiceCreditor
    settlementWallet: true, //SettlementWallet
    settlementWalletImprest: true, //Imprest/SettlementWallet
    settlementGuild: true, //SettlementGuild
    settlementGuildWithId: true, //SettlementGuild/WithId
    imprestList: true, //Imprest
    reportSummary: 'export-imprest-aggregate', //Imprest/ReportSummary/31474?ImprestName=شعبه%20جردن
    ImprestDepositReport: true,
  };

  // حداکثر بازه تاریخ به روز
  const MAX_DATE_RANGE = {
    wallet: 365,
    guild: 365,
    guildWithId: 365,
    walletImprest: 365,
    branch: 365,
    branchWithId: 365,
    imprest: 365,
    imprestWithId: 365,
    invoice: 90,
    delegationList: 90,
    delegation: 90,
    voucher: 90,
    invoiceCreditor: 30,
    imprestList: 30,
    reportSummary: 30,
    settlementWallet: 30,
    settlementWalletImprest: 30,
    settlementGuild: 30,
    settlementGuildWithId: 30,
    ImprestDepositReport:365
  };
  /**
   * پر شدن فیلد مربوط به نوع حساب
   */
  useEffect(() => {
    getCheckList();
  }, []);

  /**
   * پر شدن فیلد مربوط به نوع حساب
   */
  useEffect(() => {
    setStartDate(
      paramsData?.startDate !== null ? jMoment(paramsData?.startDate, 'jYYYY/jMM/jDD') : null,
    );
    setEndDate(paramsData?.endDate !== null ? jMoment(paramsData?.endDate, 'jYYYY/jMM/jDD') : null);
    if (type === 'reportSummary') {
      setPeriodTypeSelect(paramsData?.periodType);
    }
  }, [paramsData]);

  /**
   * پر شدن فیلد مربوط به نوع حساب
   */
  useEffect(() => {
    setSelectAccount([AccountList]);
  }, [AccountList]);

  /**
   * پر شدن فیلد مربوط به  شعبه
   */
  useEffect(() => {
    if (
      branchList !== null &&
      (type === 'branch' ||
        type === 'branchWithId' ||
        type === 'imprest' ||
        type === 'imprestWithId')
    ) {
      setSelectBranchList(branchList);
    }
  }, [branchList]);

  /**
   * در صورتی که از فیلتر تاریخ پر شده باشد این کد بررسی میکند
   */

  useEffect(() => {
    if (paramsData?.startDate !== null || paramsData?.endDate !== null) {
      if (paramsData?.startDate !== null) {
        setStartDate(jMoment(paramsData?.startDate, 'jYYYY/jMM/jDD'));
      } else {
        setStartDate(null);
      }
      if (paramsData?.endDate !== null) {
        setEndDate(jMoment(paramsData?.endDate, 'jYYYY/jMM/jDD'));
      } else {
        setEndDate(null);
      }
    } else {
      setEndDate(null);
      setStartDate(null);
    }
  }, [paramsData?.endDate || paramsData?.startDate]);

  useEffect(() => {
    if (paramsData?.dateType !== null) {
      setDateType(paramsData?.dateType);
    } else {
      setDateType(null);
    }
  }, [paramsData?.dateType]);

  /**
   * بسته شدن دیالوگ
   */
  const handleCloseDialog = () => {
    setIsOpenDg(false);
  };

  const getCheckList = async () => {
    try {
      const res = await getFeatureList();
      let list = res?.result;
      if (keyShowElement[type] === true) {
        
        setShowElement(true);
        return;
      }

      const hasKey = list.includes(keyShowElement[type]);
      setShowElement(hasKey);
    } catch (e) {}
  };

  /**
   * سرویس های هر بخش
   */
  const transactionFunctions = {
    wallet: getTransactionWalletFormat,
    guild: getTransactionGuildFormat,
    guildWithId: getTransactionGuildFormat,
    walletImprest: getTransactionWalletFormat,
    branch: getTransactionBranchFormat,
    branchWithId: getTransactionBranchFormat,
    imprest: getTransactionImprestFormat,
    imprestWithId: getTransactionImprestFormat,
    invoice: getTransactionInvoiceFormat,
    delegation: getTransactionDelegationFormat,
    delegationList: getTransactionDelegationListFormat,
    voucher: getTransactionVoucherFormat,
    invoiceCreditor: getTransactionInvoiceCreditorFormat,
    settlementWallet: getTransactionSettlementWalletFormat,
    settlementWalletImprest: getTransactionSettlementWalletFormat,
    settlementGuild: getTransactionSettlementGuildFormat,
    settlementGuildWithId: getTransactionSettlementGuildFormat,
    imprestList: getTransactionImprestListFormat,
    reportSummary: getTransactionReportSummaryFormat,
    ImprestDepositReport: getImprestDepositReportFormat,
  };

  /**
   * سرویس مربوط به فایل فراخوانی دانلود فایل
   */
  const onSubmit = async (data) => {
    const firstDate = new Date();
    if (type !== 'imprestList') {
      if (allowedTypes.includes(type) && dateType == null) {
        createToast('خطا', 'نوع تاریخ انتخاب نشده است!', 'danger');
        return;
      }
      if (type === 'reportSummary') {
        if (periodTypeSelect === null || periodTypeSelect === undefined) {
          createToast('خطا', ' فیلد دوره زمانی باید انتخاب شود!', 'danger');
          return;
        }
        if (periodTypeSelect === 'DAILY') {
          if (startDate === null || endDate === null) {
            createToast('خطا', 'تاریخ شروع و پایان باید انتخاب شود!', 'danger');
            return;
          }
        } else if (periodTypeSelect === 'MONTHLY') {
          if (startDate === null || endDate === null) {
            createToast('خطا', 'تاریخ شروع و پایان باید انتخاب شود!', 'danger');
            return;
          }
        } else {
          if (startDate === null) {
            createToast('خطا', 'فیلد سال باید انتخاب شود!', 'danger');
            return;
          }
        }
      } else {
        if (startDate === null || endDate === null) {
          createToast('خطا', 'تاریخ شروع و پایان باید انتخاب شود!', 'danger');
          return;
        }
      }
    }

    setIsLoading(true);

    try {
      const params = {
        ...paramsData,
        startDate: startDate ? enifyDateTime(startDate?.format('jYYYY/jMM/jDD')) : null,
        endDate: endDate ? enifyDateTime(endDate?.format('jYYYY/jMM/jDD')) : null,
        accountId: selectAccount !== null ? selectAccount[0]?.value : null,
        branchId: selectBranchList !== null ? selectBranchList[0]?.value : null,
        dateType: dateType !== null ? dateType : null,
      };
      if (type === 'reportSummary') {
        params.periodType = periodTypeSelect;
        if (periodTypeSelect === 'YEARLY') {
          (params.startDate = enifyDateTime(startDate?.format('jYYYY'))),
            (params.endDate = enifyDateTime(startDate?.format('jYYYY')));
        }
        if (periodTypeSelect === 'MONTHLY') {
          (params.startDate = enifyDateTime(startDate?.format('jYYYY/jMM'))),
            (params.endDate = enifyDateTime(startDate?.format('jYYYY/jMM')));
        }
      }

      const transactionFn = transactionFunctions[type];
      if (!transactionFn) {
        throw new Error('نوع معتبر نیست');
      }

      type === 'ImprestDepositReport' && (params['branchId'] = paramsData['businessId']);
      let res = await transactionFn(params, fileFormat);
      const secondDate = new Date();

      let timeBetween = secondDate - firstDate;
      if (res?.result?.redirect) {
        if (timeBetween < 6000) {
          const timeSecond = Math.ceil(timeBetween / 1000);
          setTimeout(() => {
            openNewTab(res?.result?.redirect);
          }, (6 - timeSecond) * 1000);
        } else {
          navigate(redirectPage[type]);
        }
      } else {
        setIsLoading(false);
        createToast('موفق', res?.result?.message, 'success');
        navigate(redirectPage[type]);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /**
   *باز شدن تب جدید
   */
  const openNewTab = (url) => {
    setIsLoading(false);
    handleCloseDialog();
    window.open(url, '_blank');
  };

  return (
    <React.Fragment>
      <ButtonLoading
        variant="contained"
        loading={type === 'imprestList' ? isLoading : null}
        onClick={() => {
          if (type === 'imprestList') {
            onSubmit();
          } else {
            setIsOpenDg(true);
          }
        }}
        startIcon={<Icons icon="ReceiveSquare" color="#fff" size="23" />}
        color="primary"
        name="دریافت خروجی"
        aria-controls="simple-menu"
        aria-haspopup="true"
        className={classes.button}
      />

      {showElement && redirectPage[type] && (
        <ButtonLoading
          className={classes.reciveBtn}
          variant="contained"
          onClick={() => navigate(redirectPage[type])}
          color="primary"
          name="لیست درخواست گزارشات"
        />
      )}
      <SimpleDialog
        fullWidth
        maxWidth="sm"
        open={isOpenDg}
        icon={<Icons icon="OpenNewTab" color="#303DBF" size="20" />}
        title={'تنظیمات خروجی '}
        style={{ padding: '30px' }}
        className={classes.root}
      >
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)} noValidate autoComplete="off">
            {(type === 'branch' ||
              type === 'branchWithId' ||
              type === 'imprest' ||
              type === 'imprestWithId') && (
              <Grid container alignItems="center" justifyContent="flex-start" spacing={3}>
                <Grid item xs={12} md={6}>
                  <SelectV
                    label=" نام شعبه : "
                    name="branchName1"
                    options={selectBranchList}
                    rules={['required']}
                    forceValue={selectBranchList !== null ? selectBranchList[0]?.value : null}
                    fullWidth
                    disabled={true}
                    margin="dense"
                  />
                </Grid>
              </Grid>
            )}
            {allowedTypes.includes(type) && (
              <Grid container alignItems="center" justifyContent="flex-start" spacing={3}>
                <Grid item xs={12} md={6}>
                  <SelectV
                    label=" نوع تاریخ : "
                    name="dateType"
                    options={DATE_TYPE_OPTIONS_MAP[type] || DATE_TYPE_OPTIONS_MAP.default}
                    rules={['required']}
                    forceValue={dateType !== null ? dateType : null}
                    onChangeFunc={(v, e) => setDateType(e?.target?.value || null)}
                    fullWidth
                    margin="dense"
                  />
                </Grid>
              </Grid>
            )}
            {(type === 'wallet' ||
              type === 'walletImprest' ||
              type === 'guild' ||
              type === 'guildWithId') && (
              <Grid container alignItems="center" justifyContent="flex-start" spacing={3}>
                <Grid item xs={12} md={6}>
                  <SelectV
                    label="عنوان حساب : "
                    name="accountTitle"
                    options={selectAccount}
                    rules={['required']}
                    forceValue={selectAccount !== null ? selectAccount[0]?.value : null}
                    fullWidth
                    disabled={true}
                    margin="dense"
                  />
                </Grid>
              </Grid>
            )}
            {type !== 'reportSummary' ? (
              <>
                <Grid container alignItems="center" justifyContent="first" xs={12}>
                  <Typography color="textSecondary" gutterBottom style={{ fontSize: '13px' }}>
                    <span style={{ color: '#ef5350', margin: '0 0 0 5px', fontSize: '12px' }}>
                      *
                    </span>
                    محدوده تاریخ :
                  </Typography>
                  <Tooltip title={`بازه گزارش گیری حداکثر ${MAX_DATE_RANGE[type]} روز می باشد.`}>
                    <div className={classes.BIBadge}>
                      <Icons icon="Info" color="#667585" size="17" className={classes.BIIcon} />
                    </div>
                  </Tooltip>
                </Grid>
                <Grid container alignItems="center" justifyContent="center" spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Typography color="textSecondary" gutterBottom>
                      از تاریخ:
                    </Typography>
                    <DatePickerPod>
                      <DatePicker
                        variant="inline"
                        name="startDate"
                        autoOk
                        inputVariant="outlined"
                        showTodayButton
                        todayLabel="امروز"
                        rules={['required']}
                        okLabel="تایید"
                        cancelLabel="لغو"
                        clearLabel="پاک کردن"
                        labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                        value={startDate || null}
                        onChange={(e) => setStartDate(e)}
                        maxDate={new Date()}
                      />
                    </DatePickerPod>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography color="textSecondary" gutterBottom>
                      تا تاریخ:
                    </Typography>
                    <DatePickerPod>
                      <DatePicker
                        variant="inline"
                        name="endDate"
                        autoOk
                        inputVariant="outlined"
                        showTodayButton
                        todayLabel="امروز"
                        rules={['required']}
                        okLabel="تایید"
                        cancelLabel="لغو"
                        clearLabel="پاک کردن"
                        labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                        value={endDate || null}
                        onChange={(e) => setEndDate(e)}
                        maxDate={new Date()}
                      />
                    </DatePickerPod>
                  </Grid>
                </Grid>
              </>
            ) : (
              <>
                <Grid container alignItems="center" spacing={3}>
                  <Grid item xs={12} md={6}>
                    <SelectV
                      label="دوره زمانی"
                      name="periodType"
                      options={periodType}
                      rules={['required']}
                      forceValue={periodTypeSelect}
                      fullWidth
                      margin="dense"
                      onChangeFunc={(k, e) => {
                        setPeriodTypeSelect(e.target.value);
                        setStartDate(null);
                        setEndDate(null);
                      }}
                    />
                  </Grid>
                  {periodTypeSelect === 'YEARLY' && (
                    <Grid item xs={12} md={6}>
                      <DatePickerPod label="سال" showAsterisk={true}>
                        <DatePicker
                          variant="inline"
                          autoOk
                          inputVariant="outlined"
                          views={['year']}
                          openTo="year"
                          value={startDate || null}
                          labelFunc={(date) => (date ? date.format('jYYYY') : '')}
                          onChange={(e) => setStartDate(e)}
                        />
                      </DatePickerPod>
                    </Grid>
                  )}
                </Grid>
                {periodTypeSelect === 'DAILY' && (
                  <Grid container alignItems="center" justifyContent="center" spacing={3}>
                    <Grid item xs={12} md={6}>
                      <DatePickerPod label="از تاریخ" showAsterisk={true}>
                        <DatePicker
                          variant="inline"
                          name="startDate"
                          autoOk
                          inputVariant="outlined"
                          showTodayButton
                          todayLabel="امروز"
                          rules={['required']}
                          okLabel="تایید"
                          cancelLabel="لغو"
                          clearLabel="پاک کردن"
                          labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                          value={startDate || null}
                          onChange={(e) => setStartDate(e)}
                          maxDate={new Date()}
                        />
                      </DatePickerPod>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <DatePickerPod label="تا تاریخ" showAsterisk={true}>
                        <DatePicker
                          variant="inline"
                          name="endDate"
                          autoOk
                          inputVariant="outlined"
                          showTodayButton
                          todayLabel="امروز"
                          rules={['required']}
                          okLabel="تایید"
                          cancelLabel="لغو"
                          clearLabel="پاک کردن"
                          labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                          value={endDate || null}
                          onChange={(e) => setEndDate(e)}
                          maxDate={new Date()}
                        />
                      </DatePickerPod>
                    </Grid>
                  </Grid>
                )}
                {periodTypeSelect === 'MONTHLY' && (
                  <Grid container alignItems="center" justifyContent="center" spacing={3}>
                    <Grid item xs={12} md={6}>
                      <DatePickerPod label="از تاریخ" showAsterisk={true}>
                        <DatePicker
                          variant="inline"
                          name="startDate"
                          key="startDate"
                          autoOk
                          inputVariant="outlined"
                          showTodayButton
                          todayLabel="امروز"
                          okLabel="تایید"
                          cancelLabel="لغو"
                          clearLabel="پاک کردن"
                          views={['year', 'month']}
                          openTo="month"
                          labelFunc={(date) => (date ? date.format('jYYYY/jMM') : '')}
                          value={startDate || null}
                          onChange={(date) => setStartDate(date)}
                        />
                      </DatePickerPod>
                    </Grid>
                    <Grid item xs={6}>
                      <DatePickerPod label="تا تاریخ" showAsterisk={true}>
                        <DatePicker
                          variant="inline"
                          name="endDate"
                          key="endDate"
                          autoOk
                          inputVariant="outlined"
                          showTodayButton
                          views={['year', 'month']}
                          openTo="month"
                          todayLabel="امروز"
                          okLabel="تایید"
                          cancelLabel="لغو"
                          clearLabel="پاک کردن"
                          value={endDate || null}
                          labelFunc={(date) => (date ? date.format('jYYYY/jMM') : '')}
                          onChange={(e) => setEndDate(e)}
                        />
                      </DatePickerPod>
                    </Grid>
                  </Grid>
                )}
              </>
            )}
            {showElement && isFormatExport && (
              <Grid container alignItems="center" spacing={3}>
                <Grid item xs={12} md={6}>
                  <SelectV
                    label="فرمت خروجی"
                    name="fileFormat"
                    options={filteredFileTypes}
                    forceValue={fileFormat}
                    fullWidth
                    margin="dense"
                    onChangeFunc={(k, e) => {
                      setFileFormat(e.target.value);
                    }}
                  />
                </Grid>
              </Grid>
            )}
            {isLoading && (
              <Grid>
                <div className={classes.loadingContent}>
                  <NewLoading styleLoadingDialog={true} />
                </div>
              </Grid>
            )}

            <Grid
              direction="row"
              container
              item
              xs={12}
              justifyContent="flex-end"
              style={{ marginTop: '25px', paddingRight: '22px' }}
            >
              <Button variant="contained" onClick={() => handleCloseDialog()} disabled={isLoading}>
                انصراف
              </Button>
              <ButtonLoading
                name={'دریافت خروجی'}
                type="submit"
                variant="contained"
                disabled={isLoading}
                color="primary"
                style={{ marginRight: '10px' }}
              />
            </Grid>
          </form>
        </FormProvider>
      </SimpleDialog>
    </React.Fragment>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-paper': {
      overflowY: 'hidden!important',
      '& .MuiDialogContent-root': {
        '& .bodyLoading': {
          height: '83%!important',
        },
      },
    },
  },
  button: {
    marginLeft: '5px',
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
      marginBottom: '4px',
    },
  },
  reciveBtn: {
    width: '185px',
    marginLeft: '10px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: '0',
      margin: '4px 0',
    },
  },
  loadingContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '20px',
    left: '0',
    borderRadius: '34px',
    overflow: 'hidden',
  },
  messageLoading: {
    zIndex: '10000',
    marginBottom: '30px',
    fontWeight: 'bold',
    fontSize: '14px',
    position: 'relative',
    top: 40,
  },
  BIBadge: {
    position: 'relative',
    left: 3,
  },
}));

export default ReceiveFile;
